import type { ComponentType } from "react";

import style from "./style.module.scss";
import { useStaggeredReveal } from "../../../hooks/use-scroll-reveal";

interface Feature {
  icon?: ComponentType;
  title: string;
  description: string;
}

interface FeaturesSectionProps {
  features: Feature[];
}

function FeaturesSection({ features }: FeaturesSectionProps) {
  const gridRef = useStaggeredReveal<HTMLDivElement>(120);

  if (!features || features.length === 0) {
    return null;
  }

  return (
    <section className={style.features}>
      <div className={style.featuresInner}>
        <h2 className={style.featuresTitle}>Pourquoi choisir Lymaprint ?</h2>
        <div ref={gridRef} className={style.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={style.featureCard}>
              <div className={style.featureIconWrap}>{feature.icon && <feature.icon />}</div>
              <h3 className={style.featureTitle}>{feature.title}</h3>
              <p className={style.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
